import React, { forwardRef } from "react";
import IconBase, { IconProps } from "frontend/icons/icon-base";

export const MondayPrivateBoardIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M15.0879 15.6738C15.0881 15.266 15.4183 14.9358 15.8262 14.9355C16.2342 14.9355 16.5652 15.2658 16.5654 15.6738C16.5654 16.082 16.2344 16.4131 15.8262 16.4131C15.4182 16.4129 15.0879 16.0819 15.0879 15.6738Z"
              fill={color}
            />
            <path
              d="M18.7021 14.1953C18.7021 14.0557 18.6032 13.9392 18.4717 13.9121L18.4131 13.9062H13.2393C13.0796 13.9062 12.9502 14.0356 12.9502 14.1953V17.1514L12.9561 17.21C12.983 17.3417 13.0995 17.4404 13.2393 17.4404H18.4131C18.5727 17.4404 18.7021 17.311 18.7021 17.1514V14.1953ZM19.6025 17.1514C19.6025 17.8081 19.0698 18.3408 18.4131 18.3408H13.2393C12.6236 18.3408 12.1166 17.873 12.0557 17.2734L12.0498 17.1514V14.1953C12.0498 13.5386 12.5825 13.0059 13.2393 13.0059H18.4131L18.5342 13.0117C19.134 13.0724 19.6025 13.5795 19.6025 14.1953V17.1514Z"
              fill={color}
            />
            <path
              d="M17.2246 13.4561V12.3477C17.2246 11.977 17.0766 11.6215 16.8145 11.3594C16.5852 11.1302 16.2846 10.9889 15.9648 10.957L15.8262 10.9502C15.4555 10.9502 15.1 11.0973 14.8379 11.3594C14.5758 11.6215 14.4288 11.977 14.4287 12.3477V13.4561C14.4287 13.7046 14.227 13.9062 13.9785 13.9062C13.73 13.9062 13.5283 13.7046 13.5283 13.4561V12.3477C13.5284 11.7383 13.7703 11.1535 14.2012 10.7227C14.6321 10.2918 15.2168 10.0498 15.8262 10.0498L16.0537 10.0615C16.5796 10.1138 17.0742 10.3458 17.4512 10.7227C17.8821 11.1535 18.124 11.7383 18.124 12.3477V13.4561C18.124 13.7046 17.9224 13.9062 17.6738 13.9062C17.4255 13.9061 17.2246 13.7045 17.2246 13.4561Z"
              fill={color}
            />
            <mask
              id="mask0_22379_1280"
              maskUnits="userSpaceOnUse"
              x="3"
              y="5"
              width="14"
              height="11"
              style={{ maskType: "alpha" }}
            >
              <path
                d="M14.5 14.7998V16H5.5V14.7998H14.5ZM15.7998 13.5V7.5C15.7998 6.82688 15.2884 6.27357 14.6328 6.20703L14.5 6.2002H5.5C4.78203 6.2002 4.2002 6.78203 4.2002 7.5V13.5C4.2002 14.218 4.78203 14.7998 5.5 14.7998V16L5.24414 15.9873C4.06772 15.8677 3.13227 14.9323 3.0127 13.7559L3 13.5V7.5C3 6.20566 3.98361 5.14082 5.24414 5.0127L5.5 5H14.5L14.7559 5.0127C16.0164 5.14082 17 6.20566 17 7.5V13.5L16.9873 13.7559C16.8677 14.9323 15.9323 15.8677 14.7559 15.9873L14.5 16V14.7998C15.218 14.7998 15.7998 14.218 15.7998 13.5Z"
                fill={color}
              />
              <path
                d="M7.59961 15L7.58789 15.1211C7.53188 15.3944 7.2899 15.5996 7 15.5996C6.7101 15.5996 6.46811 15.3944 6.41211 15.1211L6.40039 15L6.40039 6C6.40039 5.66863 6.66863 5.40039 7 5.40039C7.33137 5.40039 7.59961 5.66863 7.59961 6L7.59961 15Z"
                fill={color}
              />
            </mask>
            <g mask="url(#mask0_22379_1280)">
              <path d="M11 9H17.5V5H3V16H11V9Z" fill={color} />
            </g>
          </>
        );
      }}
      {...props}
      viewBox="0 0 20 20"
    >
      {props.children}
    </IconBase>
  );
});

MondayPrivateBoardIcon.displayName = "MondayPrivateBoardIcon";
